import { NextRouter } from 'next/router';

export const updateFilters = (router: NextRouter, newParams: Record<string, string>, resetPage = true) => {
  const params = new URLSearchParams(window.location.search);

  Object.entries(newParams).forEach(([key, value]) => {
    params.set(key, value);
  });

  if (resetPage) {
    params.set('page', '1');
  }

  const basePath = router.asPath.split('?')[0];
  const newUrl = `${basePath}?${params.toString()}`;
  router.replace(newUrl, undefined, { shallow: true, scroll: false });
};
